import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
  Cell,
  LabelList,
} from "recharts";

interface DataItem {
  label: string;
  value: number;
}

type WaterfallItem = {
  label: string;
  value: number;
  start: number;
  end: number;
  displayStart: number;
  height: number;
  isTotal?: boolean;
};

interface Props {
  data: DataItem[];
};

const formatValue = (v: number) =>
  v < 0
    ? `(${Math.abs(v).toLocaleString(undefined, { maximumFractionDigits: 2 })})`
    : v.toLocaleString(undefined, { maximumFractionDigits: 2 });
const VerticalTick = ({ x, y, payload }: any) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        transform="rotate(-90)"
        x={0}
        y={0}
        dy={10}
        textAnchor="end"
        fill="#374151"
        fontSize={11}
      >
        {payload.value}
      </text>
    </g>
  );
};
const CustomLabel = (props: any) => {
  const { x, y, width, height, value } = props;

  const isNegative = value < 0;

  return (
    <text
      x={x + width / 2}
      y={isNegative ? y + height + 14 : y - 8}
      fill="#111827"
      fontSize={11}
      textAnchor="middle"
    >
      {value < 0
        ? `(${Math.abs(value).toLocaleString(undefined, { maximumFractionDigits: 2 })})`
        : value.toLocaleString(undefined, { maximumFractionDigits: 2 })}
    </text>
  );
};

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload || !payload.length) return null;

  const data = payload[0].payload;

  return (
    <div className="bg-white shadow-md rounded p-2 text-xs border">
      <div className="font-semibold">{data.label}</div>
      <div>Value: {formatValue(data.value)}</div>
    </div>
  );
};

const RevenueWaterfall: React.FC<Props> = ({ data }) => {
  let cumulative = 0;

  const waterfallData: WaterfallItem[] = data.map((item) => {
    const start = cumulative;
    cumulative += item.value;
    const end = cumulative;

    return {
      label: item.label,
      value: item.value,
      start,
      end,
      displayStart: item.value >= 0 ? start : end,
      height: Math.abs(item.value),
    };
  });

 
  waterfallData.push({
    label: "Total",
    value: cumulative,
    start: 0,
    end: cumulative,
    displayStart: cumulative >= 0 ? 0 : cumulative,
    height: Math.abs(cumulative),
    isTotal: true,
  });

  return (
    <div style={{ width: "100%", height: 550 }}>
      <ResponsiveContainer>
        <ComposedChart
        // barCategoryGap="35%"
        barCategoryGap="20%"
barGap={6}
          data={waterfallData}
          margin={{ top: 20, right: 20, left: 10, bottom: 80 }}
        >
          <CartesianGrid stroke="#eee" vertical={false} />

          {/* X Axis */}
          {/* <XAxis
            dataKey="label"
            interval={0}
            height={80}
            tick={{ fontSize: 11 }}
          /> */}
<XAxis
  dataKey="label"
  interval={0}
  height={140}
  tick={{ fontSize: 11 }}
  angle={-75}
  textAnchor="end"
/>
{/* <XAxis
  dataKey="label"
  interval={0}
  height={100}
  tick={<VerticalTick />}
/> */}
          {/* Y Axis */}
          <YAxis
            tickFormatter={(v) => {
              if (Math.abs(v) >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}M`;
              if (Math.abs(v) >= 1_000) return `${(v / 1_000).toFixed(0)}k`;
              return v;
            }}
          />

          <Tooltip content={<CustomTooltip />} />

          {/* Invisible base */}
          <Bar dataKey="displayStart" stackId="a" fill="transparent" />
          

          {/* Actual bars */}
          {/* <Bar dataKey="height" stackId="a" barSize={20}> */}
          <Bar
  dataKey="height"
  stackId="a"
  barSize={65}
  maxBarSize={80}
>
            {waterfallData.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  entry.isTotal
                    ? "#4F7CAC"
                    : entry.value >= 0
                    ? "#22C55E"
                    : "#EF4444"
                }
              />
            ))}

            {/* <LabelList
              dataKey="value"
              position="top"
              formatter={(v: number) => formatValue(v)}
            /> */}
            <LabelList dataKey="value" content={<CustomLabel />} />
          </Bar>

          {/* Connector lines */}
          {waterfallData.slice(0, -1).map((entry, index) => {
            const next = waterfallData[index + 1];

            return (
              <ReferenceLine
                key={index}
                segment={[
                  { x: entry.label, y: entry.end },
                  { x: next.label, y: entry.end },
                ]}
                stroke="#9CA3AF"
                strokeWidth={1}
              />
            );
          })}

          {/* Zero line */}
          <ReferenceLine y={0} stroke="#6B7280" strokeDasharray="3 3" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueWaterfall;
